/* eslint-disable react/require-default-props */
import React from 'react';
import _get from 'lodash/get';
import { Field } from 'formik';
import ControlledDatePicker, { Props as ControlledDatePickerProps } from '@minecraft.controlled-date-picker';
import { withErrorMessage, setFieldValueAndTouched } from '@minecraft.utils';

/* ------ Types ------ */
type MergedPropNames = 'value' | 'onChange' | 'onBlur'; // merged props in ControlledDatePicker

export type FormikDatePickerProps = {
  name: string;
} & Omit<ControlledDatePickerProps, MergedPropNames>;

/* ------ Help Components ------ */
const DatePicker = ({ form, field, onChange, ...restProps }) => (
  <ControlledDatePicker
    value={_get(form.values, field.name)}
    onBlur={() => form.setTouched({ ...form.touched, [field.name]: true })}
    onChange={(date) => {
      setFieldValueAndTouched(field.name, date, form);
    }}
    {...restProps}
  />
);

/**
 * @deprecated This is an older component that does not use our standard form wrapper
 * to match the design system.
 *
 * If this component is used in application code, we want to replace it.
 * The new component is DatePickerInput from @minecraft.molecules
 *
 * import { DatePickerInput } from '@minecraft.molecules'
 *
 * <DatePickerInput name="fieldName" label="Field Label" />
 *
 * note that if you are replacing FormikDatePicker it takes a Date as the type for the form field
 * while DatePickerInput takes a properly formatted ISO date string like "2025-08-19T12:23:34.000Z"
 *
 * there is not complete compatibility for all existing FormikDatePicker use cases so you may need to
 * add new props if the existing use case does not match exactly the initial implementation of DatePickerInput
 */
const FormikDatePicker = (props: FormikDatePickerProps) => (
  <Field name={props.name} {...props}>
    {(fieldProps) => withErrorMessage(DatePicker)({ ...props, ...fieldProps })}
  </Field>
);

export default FormikDatePicker;
